module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticClass: "fontHead",
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        showBack: false
      },
      "right-options": {
        showMore: true
      }
    }
  }, [_c('router-link', {
    staticClass: "Main_left",
    attrs: {
      "slot": "left",
      "to": "/main"
    },
    slot: "left"
  }, [_vm._v(" 我的")]), _vm._v("\n    实名认证\n  ")], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "0.32rem",
      "margin-top": "3rem",
      "color": "#999"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "auto",
      "padding-bottom": ".5rem"
    },
    attrs: {
      "src": require("../../../static/img/shiming.png"),
      "alt": ""
    }
  }), _vm._v("\n    这个功能正在建设中...\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdc96aec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/certification.vue
// module id = T4j/
// module chunks = 1